module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar4-range-af734f6d.svg";